module.exports = __webpack_public_path__ + "img/客户伙伴banner.c22b1e2c.jpg";